module.exports = __webpack_public_path__ + "img/pointicon@2x.9b3a4496.svg";